// Default window size for each individual eth_getLogs call - comfortably under the range caps
// common RPC providers enforce (commonly 10-50k blocks), so a single call never gets rejected
// outright the way one wide fromBlock->latest scan would against a real mainnet deployment with
// real history. Doesn't fix the "more calls as history grows" cost, just the hard-failure mode.
const DEFAULT_CHUNK_SIZE = 40_000n

/// Same job as `client.getLogs(...)`, but internally windowed - resolves `toBlock: 'latest'` once
/// up front, then walks `fromBlock -> latest` in `chunkSize`-block windows, issuing one getLogs
/// call per window and concatenating the results. `params` takes everything a normal
/// `client.getLogs` call would (`address`, `event`, `args`, `fromBlock`) except `toBlock`, which
/// this resolves itself.
export async function getLogsChunked(client, { address, event, args, fromBlock, chunkSize = DEFAULT_CHUNK_SIZE }) {
  const latest = await client.getBlockNumber()
  if (fromBlock > latest) return []

  const windows = []
  for (let start = fromBlock; start <= latest; start += chunkSize) {
    const end = start + chunkSize - 1n > latest ? latest : start + chunkSize - 1n
    windows.push([start, end])
  }

  const results = await Promise.all(
    windows.map(([start, end]) => client.getLogs({ address, event, args, fromBlock: start, toBlock: end })),
  )
  return results.flat()
}
